import React from 'react';
import PropTypes from 'prop-types';
import DocumentClaimsChunkComponent from '@Components/Results/documents/document-claims-chunk.component';

function DocumentClaimsComponent({ closeClick, claimsText }) {
  return (
    <div className="result-detail-panel result-detail-claims">
      <div className="result-detail-panel-wrapper">
        <h4>Claims</h4>
        <div className="result-detail-block typography-small">
          <DocumentClaimsChunkComponent chunk={claimsText} />
        </div>
        <button type="button" tabIndex={0} className="els-btn els-btn-modal-close e2e-close" onClick={closeClick} aria-label="Close claims">
          <svg className="els-btn-icon els-btn-icon-tiny">
            <use xlinkHref="#icon-delete" />
          </svg>
        </button>
      </div>
    </div>
  );
}

DocumentClaimsComponent.propTypes = {
  claimsText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
};

export default DocumentClaimsComponent;
